"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMonthLabel = getMonthLabel;
exports.monthOptions = exports.EMPLOY_START_DATE = void 0;
var EMPLOY_START_DATE = 2019;
exports.EMPLOY_START_DATE = EMPLOY_START_DATE;
var monthOptions = [{
  label: 'January',
  value: 1
}, {
  label: 'February',
  value: 2
}, {
  label: 'March',
  value: 3
}, {
  label: 'April',
  value: 4
}, {
  label: 'May',
  value: 5
}, {
  label: 'June',
  value: 6
}, {
  label: 'July',
  value: 7
}, {
  label: 'August',
  value: 8
}, {
  label: 'September',
  value: 9
}, {
  label: 'October',
  value: 10
}, {
  label: 'November',
  value: 11
}, {
  label: 'December',
  value: 12
}];
exports.monthOptions = monthOptions;

function getMonthLabel(slug) {
  var _monthOptions$find;

  return (_monthOptions$find = monthOptions.find(function (_ref) {
    var value = _ref.value;
    return value === slug;
  })) === null || _monthOptions$find === void 0 ? void 0 : _monthOptions$find.label;
}